import * as React from "react";

function SvgCircleThin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.89 23.85"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M22.3 5.93a11.76 11.76 0 011.6 6 11.76 11.76 0 01-1.6 6 11.91 11.91 0 01-4.35 4.34 11.77 11.77 0 01-6 1.6 11.93 11.93 0 01-10.34-5.94 11.67 11.67 0 01-1.6-6 11.67 11.67 0 011.6-6 11.84 11.84 0 014.4-4.33 11.71 11.71 0 016-1.6 11.77 11.77 0 016 1.6 12 12 0 014.29 4.33zm-6.48-3.15a9.85 9.85 0 00-7.73 0 10.23 10.23 0 00-3.18 2.15 10.19 10.19 0 00-2.12 3.14 9.83 9.83 0 000 7.72 10.19 10.19 0 002.12 3.14 10.23 10.23 0 003.18 2.12 9.85 9.85 0 007.73 0 10.19 10.19 0 003.19-2.12 9.85 9.85 0 002.12-3.17 9.71 9.71 0 000-7.72 9.85 9.85 0 00-2.12-3.11 10.19 10.19 0 00-3.19-2.15z" />
    </svg>
  );
}

const MemoSvgCircleThin = React.memo(SvgCircleThin);
export default MemoSvgCircleThin;
